import script from "./IndustryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndustryView.vue?vue&type=script&setup=true&lang=ts"

import "./IndustryView.vue?vue&type=style&index=0&id=b88636f0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b88636f0"]])

export default __exports__